(function () {
    'use strict';

    /*
     UserChangeEmailController Module
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.changeEmail', [])

        /**
          * UserChangeEmailController - handle chnage email form view js scope
          *
          * @inject __Form
          * @inject appServices
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserChangeEmailController', [
            '__Form',
            'appServices',
            function (__Form, appServices) {

                var scope = this;

                scope.requestSuccess = false;
                scope.pageStatus = false;

                scope = __Form.setup(scope, 'user_change_email_form', 'userData', {
                    secured: true
                });

                /**
                  * Fetch support data
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                __Form.fetch('user.change_email.support_data')
                    .success(function (responseData) {

                        var requestData = responseData.data;

                        appServices.processResponse(responseData, null, function () {

                            scope.changeEmail = requestData.newEmail;
                            scope.formattedDate = requestData.formattedDate;
                            scope.humanReadableDate = requestData.humanReadableDate;

                            scope.pageStatus = true;

                        });

                    });

                /**
                  * Submit change email form action
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submit = function () {

                    __Form.process('user.change_email.process', scope)
                        .success(function (responseData) {

                            var requestData = responseData.data;

                            appServices.processResponse(responseData, null,
                                function () {
                                    scope.userData = {};
                                    if (responseData.reaction == 1) {
                                        scope.activationRequired = requestData.activationRequired;

                                        scope.requestSuccess = true;

                                        $('.lw-form').slideUp();
                                    }
                                });

                        });

                };

            }

        ]);

})();